import { ROUTES } from "@/router/routes/constants";
import { useUser } from "@/shared/account";
import type { RouteRecordRaw } from "vue-router";

const InnoDashboard = () => import("@/pages/account/innovadis/inno-dashboard.vue");
const Profile = () => import("@/pages/account/profile.vue");
const ChangePassword = () => import("@/pages/account/change-password.vue");
const Addresses = () => import("@/pages/account/addresses.vue");
const Orders = () => import("@/pages/account/orders.vue");
const InnoOrderDetails = () => import("@/pages/account/innovadis/inno-order-details.vue");
const InnoPriceAgreements = () => import("@/pages/account/innovadis/inno-price-agreements.vue");
const OrderPayment = () => import("@/pages/account/order-payment.vue");
const Lists = () => import("@/pages/account/lists.vue");
const ListDetails = () => import("@/pages/account/list-details.vue");
const InnoAccountBulkOrder = () => import("@/pages/account/innovadis/inno-account-bulk-order.vue");
const SavedForLaterDetails = () => import("@/pages/account/saved-for-later-details.vue");
const SavedCreditCards = () => import("@/pages/account/saved-credit-cards.vue");
const Impersonate = () => import("@/pages/account/impersonate.vue");

export const accountRoutes: RouteRecordRaw[] = [
  { path: "dashboard", name: "Dashboard", component: InnoDashboard },
  { path: "change-password", name: "ChangePasswordAccount", component: ChangePassword },
  { path: "profile", name: "Profile", component: Profile },
  {
    path: "addresses",
    name: "Addresses",
    component: Addresses,
    beforeEnter(_to, _from, next) {
      const { isCorporateMember } = useUser();

      if (!isCorporateMember.value) {
        next();
      } else {
        next({ name: "Dashboard" });
      }
    },
  },
  {
    path: "orders",
    children: [
      { path: "", name: "Orders", component: Orders },
      {
        path: ":orderId",
        children: [
          {
            path: "",
            name: "OrderDetails",
            component: InnoOrderDetails,
            props: true,
            meta: { hideLeftSidebar: true },
          },
          {
            path: "payment",
            name: "OrderPayment",
            component: OrderPayment,
            props: true,
            meta: { layout: "Secure" },
          },
        ],
        meta: { hideLeftSidebar: true },
      },
    ],
  },
  {
    path: "saved-for-later",
    children: [{ path: "", name: ROUTES.SAVED_FOR_LATER.NAME, component: SavedForLaterDetails }],
  },
  {
    path: "lists",
    children: [
      { path: "", name: "Lists", component: Lists },
      {
        path: ":listId",
        name: "ListDetails",
        component: ListDetails,
        props: true,
      },
    ],
  },
  { path: "bulk-order", name: "InnoAccountBulkOrder", component: InnoAccountBulkOrder },
  { path: "price-agreements", name: "InnoPriceAgreements", component: InnoPriceAgreements },
  {
    path: "saved-credit-cards",
    name: "SavedCreditCards",
    component: SavedCreditCards,
  },
  {
    path: "impersonate/:userId",
    name: "Impersonate",
    props: true,
    component: Impersonate,
  },
];
